var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.391 27.5c-1.892 0-3.146-.367-4.308-.826v-2.706c1.39.62 3.008.894 4.353.894 2.621 0 3.487-1.353 3.487-3.508v-1.032c-.752 1.146-1.869 1.903-3.532 1.903-3.26 0-4.582-1.926-4.582-5.71V9.658h3.123v6.971c0 2.041.638 3.12 2.256 3.12 1.619 0 2.735-1.377 2.735-3.12V9.658h3.123v11.787c0 3.83-2.416 6.055-6.655 6.055ZM108.129 22.133V9.658h3.122v1.995c.798-1.353 2.074-2.316 3.829-2.316v3.141a2.861 2.861 0 0 0-.638-.068c-1.914 0-3.168 1.605-3.191 3.99v5.733h-3.122ZM93.98 16.675v-1.513c0-3.922 2.553-5.825 5.858-5.825 3.305 0 5.903 1.903 5.903 5.825v1.513c0 3.899-2.598 5.802-5.903 5.802-3.305 0-5.858-1.903-5.858-5.802Zm3.191-1.536v1.536c0 2.248 1.003 3.325 2.667 3.325s2.69-1.077 2.69-3.325V15.14c0-2.248-1.026-3.303-2.69-3.303s-2.667 1.055-2.667 3.303ZM86.31 18.235v-6.123h-1.983V9.657h1.983V6.08h3.122v3.578h2.986v2.454h-2.986v5.664c0 1.56.524 2.041 1.732 2.041.456 0 1.026-.046 1.436-.16v2.568c-.524.138-1.413.252-2.12.252-2.734 0-4.17-1.536-4.17-4.242ZM78.517 18.808V4.818h3.123V17.96c0 1.4.228 1.881 1.185 1.881.456 0 .866-.069 1.117-.183v2.545c-.479.16-1.23.275-1.869.275-2.393 0-3.555-1.123-3.555-3.669ZM71.504 18.808V4.818h3.123V17.96c0 1.4.228 1.881 1.185 1.881.456 0 .866-.069 1.117-.183v2.545c-.479.16-1.231.275-1.87.275-2.392 0-3.555-1.123-3.555-3.669ZM63.565 9.337c3.305 0 5.63 1.88 5.63 5.687v2.018h-8.046c.137 1.995 1.367 2.844 3.35 2.844 1.505 0 2.735-.115 4.422-1.01v2.455c-1.504.848-2.872 1.146-4.923 1.146-3.83 0-6.017-2.04-6.017-5.802v-1.513c0-3.693 2.279-5.825 5.584-5.825Zm0 2.5c-1.527 0-2.37 1.031-2.416 3.05h4.877c-.022-2.11-.82-3.05-2.461-3.05ZM38.264 9.658h3.1l2.142 9.288 2.849-9.288h2.758l2.803 9.242 2.12-9.242h2.986l-3.51 12.705h-3.168l-2.644-8.83-2.758 8.83h-3.123L38.264 9.658Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.947c0-4.182 0-6.273.809-7.87A7.444 7.444 0 0 1 4.052.814C5.639 0 7.717 0 11.873 0h8.057c4.156 0 6.234 0 7.822.814a7.444 7.444 0 0 1 3.242 3.263c.81 1.597.81 3.688.81 7.87v8.106c0 4.182 0 6.273-.81 7.87a7.444 7.444 0 0 1-3.242 3.263C26.163 32 24.085 32 19.93 32h-8.057c-4.156 0-6.234 0-7.821-.814a7.444 7.444 0 0 1-3.243-3.263C0 26.326 0 24.235 0 20.053v-8.106Z",
    fill: "#151A22"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.291 12.871c-.183-4.53-3.452-5.444-4.979-5.4-2.033 0-3.8.705-5.307 2.114-.504.472-1.355.41-1.854-.067-1.989-1.902-5.307-2.156-7.092-1.254-2.088 1.055-3.01 2.895-3.01 4.872 0 7.904 7.977 13.167 11.118 13.167 2.618 0 11.397-6.716 11.124-13.432Z",
    fill: "url(#logo_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.482 11.029C6.352 9.317 8.707 8 10.278 7.869c1.388-.117 3.391.076 5.103 1.852.387.401 1.015.49 1.402.089.669-.691 1.283-1.382 3.441-2.073-1.57.79-2.487 1.58-4.319 3.687-1.267 1.458-2.879 2.239-5.235 2.239-1.44 0-4.034-.627-4.188-2.634Z",
    fill: "#C92E00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.869 16.56c.125.26-.005.484-.3.629-.297.144-.622.026-.747-.235-.126-.26-.004-.563.292-.708.296-.144.63.053.755.313ZM14.374 20.251c-.084-.276.079-.478.393-.575.315-.097.662.163.746.44.085.276-.126.464-.44.561-.316.097-.614-.15-.699-.426ZM8.577 17.35a.514.514 0 0 1 .32-.642c.316-.097.702.118.786.395.084.276-.17.414-.484.511-.315.097-.59-.157-.622-.264Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.054,
    cy: 12.241,
    rx: 0.222,
    ry: 0.263,
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.765 17.901c0 .218-.187.395-.477.395-.289 0-.523-.177-.523-.395 0-.218.234-.29.523-.29.29 0 .477.072.477.29ZM20.486 20.773c0 .218-.187.395-.476.395s-.57-.177-.57-.395c0-.218.281-.421.57-.421.29 0 .476.203.476.42Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.041-.489C6.4-.71 4.404-.24 2.711.924c1.965 1.127 4.488 3.235 5.892 6.333.79 1.744.421 4.506 2.387 5.492 2.168 1.088 3.977-1.455 4.492-2.535.094-.657.028-2.394-.983-4.084-1.263-2.112-2.092-2.1-4.632-4.365C8.603.638 8.61-.412 8.04-.49Z",
    fill: "url(#logo_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.409 11.95c0 .218-.307.395-.524.395a.394.394 0 0 1-.392-.395c0-.218.176-.395.392-.395.217 0 .524.177.524.395Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.074 8.331c.242-.01.453.35.464.61.01.26-.177.48-.42.49-.241.01-.446-.193-.456-.453-.011-.26.17-.637.412-.647Z",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.582 4.125c.242-.01.458.463.472.802.013.34-.171.624-.414.633-.242.01-.449-.257-.463-.597-.013-.34.163-.828.405-.838ZM17.45 6.927c.074.1-.033.304-.15.39-.118.087-.273.076-.346-.025-.073-.1-.037-.252.08-.338.118-.087.343-.128.417-.027Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.645 8.285c.085.117-.013.333-.13.42a.26.26 0 0 1-.366-.054.264.264 0 0 1 .06-.367c.117-.087.352-.115.436.001Z",
    fill: "#FF6B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47 6.402c-.115-.086-.086-.322 0-.44a.26.26 0 0 1 .366-.058c.115.086.138.25.051.369-.087.117-.302.214-.417.129Z",
    fill: "#FEA900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.503 2.205c-.143-.011-.142-.118-.131-.264.011-.146.01-.31.153-.3.143.012.25.14.238.285-.011.146-.117.29-.26.279Z",
    fill: "#CC5616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.083 4.97c-.115-.086-.038-.212 0-.264.116-.157.326-.445.393-.395.095.071.025.338-.09.495-.063.086-.188.25-.303.164Z",
    fill: "#E39932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 2.863c-.315-.21-.524-.395-.786-.395-.785 0-.523 1.185-.262 1.58.262.395 1.047.659 1.309.527s.262-.395.262-.658c0-.264-.131-.79-.524-1.054Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.718 6.682c-.654-.494-1.396-1.624-1.832-2.238-.226-.319-.39 0-.393.263 0 .263-.028 2.289.524 3.029.785 1.053 1.177 1.053 1.7.526.335-.335.524-1.185 0-1.58Z",
    fill: "#FF5B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.838 9.052c0-.263-.523-.79-.916-1.317-.314-.421-.741-.439-.916-.395-.087 0-.288.08-.392.395-.131.395.13.79.392.922.117.059.655.132 1.047.527.334.335.785.131.785-.132ZM14.855 11.677c-.44.366-1.363.919-1.983 1.129-.136.046-.277-.03-.329-.164-.226-.582-.417-1.164-.301-1.746.226-1.14.741-1.097 1.047-.921.572.329 1.237.389 1.639 1.408a.258.258 0 0 1-.073.294Z",
    fill: "#FF6B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__b",
    x: -12.329,
    y: -7.934,
    width: 55.428,
    height: 57.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.901
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.901
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.327091 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15_161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__c",
    x: 1.099,
    y: 3.519,
    width: 26.199,
    height: 22.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.95,
    dy: -3.95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_15_161"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.35375 19.10304 -18.10102 2.23029 13.552 9.307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#B80747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__e",
    x1: 9.102,
    y1: 9,
    x2: 4.723,
    y2: -0.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31.803v32H0z"
  })))));
};
export default SvgLogo;